import { connect } from 'react-redux';
import { setView } from 'common/gantt/containers/gantt-actions';
import PeriodDropdown from '../components/planning-board-period-dropdown';

const mapStateToProps = state => ({
  activePeriod: state.gantt.view,
  boardData: state.gantt.boardData,
});

const mapDispatchToProps = {
  updatePeriod: setView,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PeriodDropdown);
